import { useContext } from 'react';

import { loadName } from 'helpers/loads';
import { ProjectContext } from 'components/layouts/Project';
import LogsReportPage from './LogsReportPage';
import HelicalLogReportPage from './HelicalLogReportPage';
import PushPierLogReportPage from './PushPierLogReportPage';
import { ROWS_PER_PAGE } from 'helpers/pileLogs';

const pilesPerPage = (load) => load?.pileType == 'helical' ? 6 : 2;
const presentRow = ([_depth, ...row]) => _.some(row, _.isPresent);
const findLastIndexOf = (coll, predicate) => _.indexOf(coll, _.findLast(coll, predicate));

const pages = (loads, logs) => {
  return _.flatMap(loads, (load, i) => {
    const allPiles = _.get(logs, ['loads', load.id, 'piles']);
    const presentPiles = _.filter(_.values(allPiles), _.isPresent);
    if (presentPiles.length == 0) return [];

    const piles = _.compact(_.range(1, load.pileCount + 1).map((pileNo) => {
      const pileLog = _.get(allPiles, pileNo);
      if (_.isPresent(pileLog)) {
        const depthRows = findLastIndexOf(pileLog.measurements, presentRow) + 1;
        return {pileNo, depthRows, ...pileLog};
      }
    }));
    return _.flatMap(_.chunk(piles, pilesPerPage(load)), (pilesForPage) => {
      const maxDepthRows = _.maxOf(pilesForPage, 'depthRows');
      const numberOfPages = 1 + _.ceil(maxDepthRows < 15 ? 0 : (maxDepthRows - 15) / ROWS_PER_PAGE);
      return _.range(1, numberOfPages + 1).map((pageNumber) => ({
        ..._.pick(load, 'pileType'),
        loadName: loadName(load, i),
        piles: pilesForPage,
        maxDepthRows,
        pageNumber: pageNumber,
        numberOfPages
      }));
    });
  });
};

export default function LogsReport({project})  {
  project = project ?? useContext(ProjectContext);
  const {data: {loads, logs}} = project ?? {};

  return (
    <div className="logs-report">
      {pages(loads, logs).map((page) => (
        <LogsReportPage key={page.loadName + page.piles[0].pileNo + page.pageNumber}>
          {page.pileType === 'helical' ? (
            <HelicalLogReportPage page={page} project={project}/>
          ) : (
            <PushPierLogReportPage page={page} project={project}/>
          )}
        </LogsReportPage>
      ))}
    </div>
  );
}
